import { route } from "@circle-react/lib/routes/define";

export const siteRoutes = {
  index: route("/settings/home", {
    title: "Defaults",
    requires: "admin",
    description:
      "Configure default landing pages for new and existing members and logged-out visitors. Member email visibility and other account controls are configured separately in General settings.",
  }),

  navigation: route("/settings/navigation", {
    title: "Navigation",
    requires: "admin",
    description:
      "Manage the community's top-level navigation links — add, reorder, and edit items shown in the main nav (including links into the Circle directory).",
    queryParams: {
      selectedLinkId: {
        type: "number",
        description:
          "When present, the page auto-opens the edit-link modal for this navigation link id on mount. Used to deep-link from elsewhere in the app (e.g. the admin-only-route notice) straight into editing a specific link.",
      },
      isCircleDirectoryLink: {
        type: "boolean",
        description:
          "Paired with `selectedLinkId`. When `true`, the edit modal opens in Circle-directory-link mode, which locks the link kind to `custom`. Set this for links auto-derived from Circle directory items; omit (or pass non-`true`) for regular community-defined navigation links.",
      },
    },
  }),

  seo: route("/settings/seo", {
    title: "SEO",
    requires: "admin",
    description:
      "Configure community SEO settings: site title, meta description, social preview image, indexing controls.",
  }),

  redirects: route("/settings/redirects", {
    title: "Redirects",
    requires: "admin",
    description:
      "Manage URL redirects for the community — create and edit source → destination redirect rules.",
  }),

  codeSnippets: route("/settings/code_snippets", {
    title: "Code snippets",
    requires: "admin",
    description:
      "Inject custom HTML / JS / CSS snippets into the community (e.g. analytics tags, third-party widgets, custom styles).",
  }),
};
